import { TransformedStoreItem } from "@/(admin)/modules/ui-builder/config/themes/tamda-foods/StoreInfo/type"
import { getFixedT } from "@/languages/i18n"

const RightSidebar = ({ store, locale }: { store: TransformedStoreItem; locale?: string }) => {
  const t = getFixedT(locale)
  return (
    <>
      {/* Right: Information */}
      <div className="w-full sm:w-[51.2%] flex sm:flex-row flex-col sm:p-2 sm:gap-0 gap-8">
        {store.openingHours && store.openingHours.length > 0 && (
          <div className="w-full flex flex-col gap-3">
            <h3 className="text-[14px] leading-[21.7px] text-[#333] font-semibold">{t("Opening hours")}</h3>
            <div className="flex flex-col gap-1">
              {store.openingHours.map((item, idx) => (
                <div
                  key={idx}
                  className="sm:w-[220px] w-full pt-1 pb-2 border-b border-[#0000001a] flex justify-between"
                >
                  <span className="text-[14px] leading-[21.7px] font-normal text-[#333]">{t(item.day)}</span>
                  <span className="text-[14px] leading-[21.7px] font-normal text-[#333]">{item.hours}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {store.guidance && (
          // Render thẳng HTML guidance đã soạn trong editor (đã có sẵn cấu trúc/
          // style). Typography khớp theme qua các selector con để mọi định dạng
          // (h4 tiêu đề, <p>, <strong>) đều hiển thị đúng.
          <div
            className="w-full text-[#333] text-[14px] leading-[21.7px] [&_h2]:text-base [&_h3]:text-base [&_h4]:text-base [&_h2]:font-bold [&_h3]:font-bold [&_h4]:font-bold [&_h2]:leading-[24.8px] [&_h3]:leading-[24.8px] [&_h4]:leading-[24.8px] [&_h2]:mb-3 [&_h3]:mb-3 [&_h4]:mb-3 [&_p]:mb-2 [&_strong]:font-semibold [&_a]:underline"
            dangerouslySetInnerHTML={{ __html: store.guidance }}
          />
        )}
      </div>
    </>
  )
}

export default RightSidebar
